import { Button, Flex, Popconfirm } from "antd";
import type { ReactNode } from "react";

export interface EntityHeaderActionsProps {
  prefix?: ReactNode;

  onBack?: () => void;
  backText?: ReactNode;
  backDisabled?: boolean;

  onSave?: () => void;
  saveText?: ReactNode;
  saveLoading?: boolean;
  saveDisabled?: boolean;

  onDelete?: () => void;
  deleteText?: ReactNode;
  deleteLoading?: boolean;
  deleteDisabled?: boolean;
  deleteConfirmTitle?: ReactNode;
  deleteConfirmDescription?: ReactNode;
  deleteConfirmOkText?: ReactNode;
  deleteConfirmCancelText?: ReactNode;
}

const EntityHeaderActions = ({
  prefix,
  onBack,
  backText = "Назад",
  backDisabled,
  onSave,
  saveText = "Сохранить",
  saveLoading,
  saveDisabled,
  onDelete,
  deleteText = "Удалить",
  deleteLoading,
  deleteDisabled,
  deleteConfirmTitle = "Удалить запись?",
  deleteConfirmDescription = "Действие необратимо.",
  deleteConfirmOkText = "Удалить",
  deleteConfirmCancelText = "Отмена",
}: EntityHeaderActionsProps) => (
  <Flex align="center" gap={8} wrap>
    {prefix}
    {onBack ? (
      <Button onClick={onBack} disabled={backDisabled}>
        {backText}
      </Button>
    ) : null}
    {onSave ? (
      <Button type="primary" onClick={onSave} loading={saveLoading} disabled={saveDisabled}>
        {saveText}
      </Button>
    ) : null}
    {onDelete ? (
      <Popconfirm
        title={deleteConfirmTitle}
        description={deleteConfirmDescription}
        onConfirm={onDelete}
        okText={deleteConfirmOkText}
        cancelText={deleteConfirmCancelText}
      >
        <Button danger loading={deleteLoading} disabled={deleteDisabled}>
          {deleteText}
        </Button>
      </Popconfirm>
    ) : null}
  </Flex>
);

export default EntityHeaderActions;
